<template>
  <div class="box-body">
    <div>
      <lte-button
        style="float:right"
        type="btn btn-primary"
        v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('create_case')"
        right_icon="fa fa-plus"
        @click="addNew($event)"
        >{{ $t("invoice.addnew") }}</lte-button
      >
    </div>
    <div>
      <b-table outlined :items="positionItems" :fields="DepartmentFields">
        <template #head()="scope">
          <div class="">{{ $t(scope.label) }}</div>
        </template>
        <template #cell(actions)="row">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-danger dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="fa fa-fw fa-ellipsis-h"></i>
            </button>
            <ul class="dropdown-menu" style="min-width: 50px;">
              <li>
                <button
                  v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('update_case')"
                  class="btn btn-primary btn-sm"
                  style="margin-left: 6px;"
                  @click="onShowDetail(row.item)"
                >
                  <i class="glyphicon glyphicon-edit"></i>
                </button>
              </li>
              <li style="margin-top: 5px">
                <button
                  v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('delete_case')"
                  class="btn btn-danger btn-sm"
                  style="margin-left: 6px;"
                  @click="onDeleteDepartment(row)"
                >
                  <i class="glyphicon glyphicon-trash"></i>
                </button>
              </li>
            </ul>
          </div>
        </template>
      </b-table>
      <div class="box-footer clearfix" style="display:contents;">
        <custom-paginator
          :totalItem="paginateData.totalItem"
          :currentPage="paginateData.currentPage"
          :pageSize="paginateData.pageSize"
          :totalPage="paginateData.totalPage"
          @onpaginate="onCustomPagination"
        />
      </div>
      <!--  -->
    </div>
    <!-- Modal modal-department -->
    <div
      class="modal fade"
      :ref="`modal-department`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  positionData.id === 0
                    ? "position.addPosition"
                    : "position.positionDetail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="">{{ $t("position.positionName") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="positionData.positionName"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button type="button" class="btn btn-primary" @click="onSave">
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- Modal modal-user-in-department-list -->
    <div
      class="modal fade"
      :ref="`modal-user-in-department-list`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("feedback.config.userInDepartmentList") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <lte-button
                  style="float:right"
                  type="btn btn-primary"
                  v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('create_case')"
                  right_icon="fa fa-plus"
                  @click="addUserInDepartment($event)"
                  >{{ $t("invoice.addnew") }}</lte-button
                >
              </div>
              <div class="col-md-12" style="margin-top: 10px">
                <b-table
                  outlined
                  :items="userInDepartmentList"
                  :fields="userInDepartmentFields"
                >
                  <template #head()="scope">
                    <div class="">{{ $t(scope.label) }}</div>
                  </template>
                  <template #cell(actions)="row">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-danger dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="true"
                      >
                        <i class="fa fa-fw fa-ellipsis-h"></i>
                      </button>
                      <ul class="dropdown-menu" style="min-width: 50px;">
                        <li style="margin-top: 5px">
                          <button
                            v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('delete_case')"
                            class="btn btn-danger btn-sm"
                            style="margin-left: 6px;"
                            @click="onDeleteDepartment(row)"
                          >
                            <i class="glyphicon glyphicon-trash"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-right"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomPaginator from "@/components/CustomPaginator.vue";
import LTEButton from "@/components/LTEButton.vue";
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
export default {
  components: {
    "lte-button": LTEButton,
    CustomPaginator
  },
  data: () => ({
    DepartmentFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "positionName",
        label: "position.positionName"
      },
      { key: "actions", label: "common.action" }
    ],
    positionItems: [],
    positionData: {
      id: 0,
      positionName: null
    },
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    userInDepartmentList: [],
    userInDepartmentFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "fullName",
        label: "customer.fullname"
      },
      {
        key: "email",
        label: "customer.email"
      },
      { key: "actions", label: "common.action" }
    ],
    staffList: [],
    staffSelect: null,
    staffExcludeDepartmentList: []
  }),
  watch: {
    GET_POSITION_LIST_DATA: function() {
      let data = this.GET_POSITION_LIST_DATA.results;
      let paginate = this.GET_POSITION_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.positionItems = [];
      data.forEach((value, i) => {
        let nonumber =
          i +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: nonumber,
          positionName: value.name
        };
        this.positionItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_POSITION_LIST_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    addNew: function(event) {
      event.preventDefault();
      $(this.$refs[`modal-department`]).modal("show");
      this.positionData = {
        id: 0,
        positionName: null
      };
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-department`]).modal("show");
      this.positionData.id = data.id;
      this.positionData.positionName = data.positionName;
    },
    onDeleteDepartment: function() {},
    getDepartmentList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_POSITION_LIST(filter);
    },
    onSave: function() {
      if (utils.isEmptyString(this.positionData.positionName)) {
        this.ON_SHOW_TOAST({
          message: this.$t("position.positionName"),
          styleType: "danger"
        });
      } else {
        let data = {
          id: this.positionData.id,
          name: this.positionData.positionName
        };
        if (this.positionData.id === 0) {
          this.CREATE_POSITION(data)
            .then(
              function() {
                $(this.$refs[`modal-department`]).modal("hide");
                this.getDepartmentList(this.paginateData.currentPage);
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST();
              }.bind(this)
            );
        } else {
          this.UPDATE_POSITION(data)
            .then(
              function() {
                $(this.$refs[`modal-department`]).modal("hide");
                let currentPage = this.paginateData.currentPage;
                let totalPage = this.paginateData.totalPage;
                let page =
                  currentPage >= totalPage && this.gridCaseDataList.length == 1
                    ? totalPage >= 2
                      ? totalPage - 1
                      : 1
                    : currentPage;
                this.getDepartmentList(page);
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST();
              }.bind(this)
            );
        }
      }
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getDepartmentList(data);
    },
    onRefreshData: function() {
      this.getDepartmentList(1);
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_POSITION_LIST",
      "CREATE_POSITION",
      "UPDATE_POSITION",
    ])
  },
  mounted() {
    this.getDepartmentList(1)
  }
};
</script>
<style scoped>
.modal {
  text-align: center;
}

.modal:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/Position/PositionList.vue